import { Layout, Menu } from "antd";
import React from "react";
import { matchPath, useLocation, useHistory } from "react-router-dom";

const { Header } = Layout;

export const routes = {
  home: "/",
  search: "/buscar",
};

const menuKeys = {
  home: "home",
  search: "search",
};

function getSelectedMenu(pathname) {
  return Object.values(menuKeys).find((key) => {
    return matchPath(pathname, {
      path: routes[key],
      exact: true,
      strict: false,
    });
  });
}

export function Navigation() {
  const location = useLocation();
  const history = useHistory();
  return (
    <Header className="header">
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[getSelectedMenu(location.pathname)]}
      >
        <Menu.Item
          onClick={() => history.push(routes.home)}
          key={menuKeys.home}
        >
          Ingreso
        </Menu.Item>
        <Menu.Item
          onClick={() => history.push(routes.search)}
          key={menuKeys.search}
        >
          Buscar
        </Menu.Item>
      </Menu>
    </Header>
  );
}
